import type { ReactNode } from 'react'

export function PageHero({
  eyebrow,
  titre,
  logo,
  children,
}: {
  eyebrow?: string
  titre: string
  /** Logo de marque officiel à afficher à la place du titre texte (blanc sur transparent). */
  logo?: { src: string; alt: string; className?: string }
  children?: ReactNode
}) {
  return (
    <section className="bg-navy text-white">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:px-8 lg:py-20">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-orange">{eyebrow}</p>
        )}
        {logo ? (
          <>
            <img src={logo.src} alt={logo.alt} className={`animate-fade-up mt-4 ${logo.className ?? 'h-14 w-auto sm:h-16'}`} />
            <h1 className="sr-only">{titre}</h1>
          </>
        ) : (
          <h1 className="animate-fade-up mt-3 font-display text-3xl font-extrabold leading-tight sm:text-4xl lg:text-5xl">
            {titre}
          </h1>
        )}
        {children && <div className="mt-5 max-w-2xl text-lg leading-relaxed text-white/85">{children}</div>}
      </div>
    </section>
  )
}
